export enum ComponentStatus {
  ACCEPTED = 'accepted',
  DELETED = 'deleted',
  PENDING = 'pending',
  REJECTED = 'rejected',
}

export enum ComponentType {
  PART = 'part',
}
